import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/edit-plus-icon.svg'
import _imports_1 from '@/assets/installation-image-comment.svg'
import _imports_2 from '@/assets/calendar-icon.svg'
import _imports_3 from '@/assets/image-user-hover.svg'
import _imports_4 from '@/assets/comment-icon-v2.svg'


const _hoisted_1 = { class: "flex flex-col relative" }
const _hoisted_2 = { class: "text-[18px] leading-[32px] tracking-[0.01rem] text-primary-text-color font-semibold bg-[#E5E4E2]" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = { class: "gap-[6px] flex flex-wrap w-full" }
const _hoisted_5 = ["onClick", "onMouseenter", "onMouseleave"]
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-center absolute right-2 bottom-2"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 2,
  class: "bg-[#E5E4E2] w-[300px] h-[300px] p-3 rounded-primary-radius cursor-pointer z-10"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "h-1/6 flex flex-col items-start gap-1" }
const _hoisted_11 = { class: "text-sm text-primary-text-color font-normal" }
const _hoisted_12 = { class: "flex items-center gap-2" }
const _hoisted_13 = { class: "flex items-center gap-1" }
const _hoisted_14 = { class: "text-sm text-primary-text-color font-normal" }
const _hoisted_15 = { class: "flex items-center gap-1" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 0,
  class: "flex items-start gap-1"
}
const _hoisted_18 = { class: "text-base leading-5 tracking-[0.01rem] text-primary-text-color font-normal" }

import FocusModeModal from "@/components/FocusMode/FocusModeModal.vue";
import { FocusImage } from "@/types";
import { ref } from "vue";

type Props = {
  input: any;
  step: any;
  steps: any;
  showDetails?: boolean;
  isGroup?: boolean;
  headerClass: string;
  repeatableGroupDetails?: {
    id: number;
    name: string;
    order: number;
  };
};

type Emits = {
  (event: "addImageModalOpen"): void;
  (event: "refresh"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'SlideImagesBlock',
  props: {
    input: {},
    step: {},
    steps: {},
    showDetails: { type: Boolean },
    isGroup: { type: Boolean },
    headerClass: {},
    repeatableGroupDetails: {}
  },
  emits: ["addImageModalOpen", "refresh"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const hoverStates = ref<any>([]);

const isFocusModeModalOpen = ref(false);
const selectedImage = ref<FocusImage | null>(null);

const toggleFocusModeModal = (image: FocusImage) => {
  selectedImage.value = {
    ...image,
    inputId: props.input.id,
    stepId: props.step.id,
    repeatableGroupIndex: props.input.repeatableGroupIndex,
  };
  isFocusModeModalOpen.value = !isFocusModeModalOpen.value;
};

const onCloseFocusModal = () => {
  isFocusModeModalOpen.value = false;
  selectedImage.value = null;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (isFocusModeModalOpen.value && selectedImage.value)
          ? (_openBlock(), _createBlock(FocusModeModal, {
              key: 0,
              "current-step": __props.step,
              "current-input": __props.input,
              image: selectedImage.value,
              steps: __props.steps,
              "repeatable-group-detail": __props.repeatableGroupDetails,
              onOnClose: onCloseFocusModal,
              onRefresh: _cache[0] || (_cache[0] = 
          () => {
            _ctx.$emit('refresh');
          }
        )
            }, null, 8, ["current-step", "current-input", "image", "steps", "repeatable-group-detail"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["w-full flex items-center justify-between bg-[#E5E4E2] min-h-12", __props.headerClass])
      }, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.input.name), 1),
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            onClick: _cache[1] || (_cache[1] = () => _ctx.$emit('addImageModalOpen')),
            class: "cursor-pointer",
            src: _imports_0,
            alt: "Add icon"
          })
        ])
      ], 2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.input.value, (image) => {
            return (_openBlock(), _createElementBlock("a", {
              class: "w-[300px] no-underline relative rounded-primary-radius",
              key: image.logId,
              onClick: ($event: any) => (toggleFocusModeModal(image)),
              onMouseenter: () => (hoverStates.value[image.logId] = true),
              onMouseleave: () => (hoverStates.value[image.logId] = false)
            }, [
              (image.comment && !hoverStates.value[image.logId])
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("img", {
                      src: _imports_1,
                      alt: "Comment"
                    }, null, -1)
                  ]))]))
                : _createCommentVNode("", true),
              (!hoverStates.value[image.logId])
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "w-[300px] h-[300px] object-cover rounded-primary-radius",
                    src: image.imageUrl,
                    alt: "Project image",
                    loading: "lazy"
                  }, null, 8, _hoisted_7))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("img", {
                      class: _normalizeClass(["object-cover rounded-primary-radius mb-2", 
                  image.comment && hoverStates.value[image.logId]
                    ? 'w-full h-4/6'
                    : 'w-full h-5/6'
                ]),
                      src: image.imageUrl,
                      alt: "Project image",
                      loading: "lazy"
                    }, null, 10, _hoisted_9),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", _hoisted_11, _toDisplayString(image.terminName), 1),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _cache[3] || (_cache[3] = _createElementVNode("img", {
                            class: "w-4 h-4",
                            src: _imports_2
                          }, null, -1)),
                          _createElementVNode("p", _hoisted_14, _toDisplayString(new Date(image.createdAt).toLocaleDateString("de")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _cache[4] || (_cache[4] = _createElementVNode("img", {
                            src: _imports_3,
                            alt: ""
                          }, null, -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(image.workers, (worker, index) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: index,
                              class: "text-sm text-primary-text-color font-normal"
                            }, [
                              _createTextVNode(_toDisplayString(worker.fullname), 1),
                              (index < image.workers.length - 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, ","))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ]),
                      (image.comment)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _cache[5] || (_cache[5] = _createElementVNode("img", {
                              src: _imports_4,
                              alt: "Comment"
                            }, null, -1)),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(image.comment && image.comment.length > 97
                        ? image.comment.substring(0, 80).trim() + "..."
                        : image.comment), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
            ], 40, _hoisted_5))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})